import React from "react";

export default function EditFieldDragIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.05025 5.59025C5.42153 5.59429 4.85265 5.21814 4.61018 4.63804C4.36771 4.05795 4.49968 3.38884 4.94426 2.94426C5.38884 2.49968 6.05795 2.36771 6.63804 2.61018C7.21814 2.85265 7.59429 3.42153 7.59025 4.05025C7.59025 4.90077 6.90077 5.59025 6.05025 5.59025Z"
        fill="#12344D"
      />
      <path
        d="M14.0502 5.59025C13.4215 5.59429 12.8527 5.21814 12.6102 4.63804C12.3677 4.05795 12.4997 3.38884 12.9443 2.94426C13.3888 2.49968 14.0579 2.36771 14.638 2.61018C15.2181 2.85265 15.5943 3.42153 15.5902 4.05025C15.5902 4.90077 14.9008 5.59025 14.0502 5.59025Z"
        fill="#12344D"
      />
      <path
        d="M6.05025 11.5902C5.42153 11.5943 4.85265 11.2181 4.61018 10.638C4.36771 10.0579 4.49968 9.38884 4.94426 8.94426C5.38884 8.49968 6.05795 8.36771 6.63804 8.61018C7.21814 8.85265 7.59429 9.42153 7.59025 10.0502C7.59025 10.9008 6.90077 11.5902 6.05025 11.5902Z"
        fill="#12344D"
      />
      <path
        d="M14.0502 11.5902C13.4215 11.5943 12.8527 11.2181 12.6102 10.638C12.3677 10.0579 12.4997 9.38884 12.9443 8.94426C13.3888 8.49968 14.0579 8.36771 14.638 8.61018C15.2181 8.85265 15.5943 9.42153 15.5902 10.0502C15.5902 10.9008 14.9008 11.5902 14.0502 11.5902Z"
        fill="#12344D"
      />
      <path
        d="M6.05025 17.5902C5.42153 17.5943 4.85265 17.2181 4.61018 16.638C4.36771 16.0579 4.49968 15.3888 4.94426 14.9443C5.38884 14.4997 6.05795 14.3677 6.63804 14.6102C7.21814 14.8527 7.59429 15.4215 7.59025 16.0502C7.59025 16.9008 6.90077 17.5902 6.05025 17.5902Z"
        fill="#12344D"
      />
      <path
        d="M14.0502 17.5902C13.4215 17.5943 12.8527 17.2181 12.6102 16.638C12.3677 16.0579 12.4997 15.3888 12.9443 14.9443C13.3888 14.4997 14.0579 14.3677 14.638 14.6102C15.2181 14.8527 15.5943 15.4215 15.5902 16.0502C15.5902 16.9008 14.9008 17.5902 14.0502 17.5902Z"
        fill="#12344D"
      />
    </svg>
  );
}
